export default {
  green: {
    agreement: require("@/assets/images/icons/f_agreement.png"),
    control: require("@/assets/images/icons/f_control.png"),
    exit: require("@/assets/images/icons/f_exit.png"),
    history: require("@/assets/images/icons/f_history.png"),
    inpoint: require("@/assets/images/icons/f_inpoint.png"),
    linklist: require("@/assets/images/icons/f_linklist.png"),
    meetingtemplate: require("@/assets/images/icons/f_meetingtemplate.png"),
    terminalcontrol: require("@/assets/images/icons/f_terminalcontrol.png"),
    meeting: require("@/assets/images/icons/f_meeting.png"),
    message: require("@/assets/images/icons/f_message.png"),
    nopoint: require("@/assets/images/icons/f_nopoint.png"),
    point: require("@/assets/images/icons/f_point.png"),
    position: require("@/assets/images/icons/f_position.png"),
    scan: require("@/assets/images/icons/f_scan.png"),
    index1: require("@/assets/images/icons/index1.png"),
    index2: require("@/assets/images/icons/index2.png"),
    index3: require("@/assets/images/icons/index3.png"),
    index4: require("@/assets/images/icons/index4.png"),
    people: require("@/assets/images/icons/g_people.png"),
    room: require("@/assets/images/icons/g_room.png"),
    nowmeet: require("@/assets/images/icons/g_nowmeet.png"),
    qiu: require("@/assets/images/icons/f_q.png"),
    control_addterminal: require("@/assets/images/meetingcontrol/green/addterminal.png"),
    control_adduser: require("@/assets/images/meetingcontrol/green/adduser.png"),
    control_audiocontrol: require("@/assets/images/meetingcontrol/green/audiocontrol.png"),
    control_broadcast: require("@/assets/images/meetingcontrol/green/broadcast.png"),
    control_liveshare: require("@/assets/images/meetingcontrol/green/liveshare.png"),
    control_lock: require("@/assets/images/meetingcontrol/green/lock.png"),
    control_splitscreen: require("@/assets/images/meetingcontrol/green/splitscreen.png"),
    control_template: require("@/assets/images/meetingcontrol/green/template.png"),
    control_videocontrol: require("@/assets/images/meetingcontrol/green/videocontrol.png"),
    control_recording: require("@/assets/images/meetingcontrol/green/recording.png"),
    control_recordover: require("@/assets/images/meetingcontrol/green/recordover.png"),
    control_recordstart: require("@/assets/images/meetingcontrol/green/recordstart.png"),
    control_recordstop: require("@/assets/images/meetingcontrol/green/recordstop.png"),
    control_broadcastpolling: require("@/assets/images/meetingcontrol/green/broadcastpolling.png"),
    control_checkinrecords: require("@/assets/images/meetingcontrol/green/checkinrecords.png"),
    control_doublestream: require("@/assets/images/meetingcontrol/green/doublestream.png"),
    control_oneclickpolling: require("@/assets/images/meetingcontrol/green/oneclickpolling.png"),
    control_broadcastno: require("@/assets/images/meetingcontrol/common/broadcastno.png"),
    control_close: require("@/assets/images/meetingcontrol/common/close.png"),
    control_locked: require("@/assets/images/meetingcontrol/common/locked.png"),
    control_norecord: require("@/assets/images/meetingcontrol/common/norecord.png"),
    control_novideo: require("@/assets/images/meetingcontrol/common/novideo.png"),
    control_novoice: require("@/assets/images/meetingcontrol/common/novoice.png"),
    control_over: require("@/assets/images/meetingcontrol/common/over.png"),
    control_warning: require('@/assets/images/meetingcontrol/common/warning.png'),
    control_blank: require('@/assets/images/meetingcontrol/common/blank.png'),
    boradcastNo: require('@/assets/images/meetingcontrol/common/boradcastNo.png'),
    clickpollingNo: require('@/assets/images/meetingcontrol/common/clickpollingNo.png'),
    VV_call:require('@/assets/images/VVimage/VVcall.png'),
    VV_back:require('@/assets/images/VVimage/VVback.png'),
    VV_date:require('@/assets/images/VVimage/VVdate.png'),
    VV_host:require('@/assets/images/VVimage/VVhost.png'),
    VV_number:require('@/assets/images/VVimage/VVnumber.png'),
    VV_people:require('@/assets/images/VVimage/VVpeople.png'),
    VV_select:require('@/assets/images/VVimage/VVselsect.png'),
    VV_time:require('@/assets/images/VVimage/VVselsect.png'),
    VV_password:require('@/assets/images/VVimage/VVpassword.png'),
    VV_Header:require('@/assets/images/VVimage/vvHeader.png'),
    VV_selecttop:require('@/assets/images/VVimage/VVselsecttop.png'),
  },
  black: {
    agreement: require("@/assets/images/icons/b_agreement.png"),
    control: require("@/assets/images/icons/b_control.png"),
    exit: require("@/assets/images/icons/b_exit.png"),
    history: require("@/assets/images/icons/b_history.png"),
    inpoint: require("@/assets/images/icons/b_inpoint.png"),
    linklist: require("@/assets/images/icons/b_linklist.png"),
    meetingtemplate: require("@/assets/images/icons/b_meetingtemplate.png"),
    terminalcontrol: require("@/assets/images/icons/b_terminalcontrol.png"),
    meeting: require("@/assets/images/icons/b_meeting.png"),
    message: require("@/assets/images/icons/b_message.png"),
    nopoint: require("@/assets/images/icons/b_nopoint.png"),
    point: require("@/assets/images/icons/b_point.png"),
    position: require("@/assets/images/icons/b_position.png"),
    scan: require("@/assets/images/icons/b_scan.png"),
    index1: require("@/assets/images/icons/index1.png"),
    index2: require("@/assets/images/icons/index2.png"),
    index3: require("@/assets/images/icons/index3.png"),
    index4: require("@/assets/images/icons/index4.png"),
    people: require("@/assets/images/icons/b_people.png"),
    room: require("@/assets/images/icons/b_room.png"),
    nowmeet: require("@/assets/images/icons/b_nowmeet.png"),
    qiu: require("@/assets/images/icons/b_q .png"),
    control_addterminal: require("@/assets/images/meetingcontrol/black/addterminal.png"),
    control_adduser: require("@/assets/images/meetingcontrol/black/adduser.png"),
    control_audiocontrol: require("@/assets/images/meetingcontrol/black/audiocontrol.png"),
    control_broadcast: require("@/assets/images/meetingcontrol/black/broadcast.png"),
    control_liveshare: require("@/assets/images/meetingcontrol/black/liveshare.png"),
    control_lock: require("@/assets/images/meetingcontrol/black/lock.png"),
    control_splitscreen: require("@/assets/images/meetingcontrol/black/splitscreen.png"),
    control_template: require("@/assets/images/meetingcontrol/black/template.png"),
    control_videocontrol: require("@/assets/images/meetingcontrol/black/videocontrol.png"),
    control_recording: require("@/assets/images/meetingcontrol/black/recording.png"),
    control_recordover: require("@/assets/images/meetingcontrol/black/recordover.png"),
    control_recordstart: require("@/assets/images/meetingcontrol/black/recordstart.png"),
    control_recordstop: require("@/assets/images/meetingcontrol/black/recordstop.png"),
    control_broadcastpolling: require("@/assets/images/meetingcontrol/black/broadcastpolling.png"),
    control_checkinrecords: require("@/assets/images/meetingcontrol/black/checkinrecords.png"),
    control_doublestream: require("@/assets/images/meetingcontrol/black/doublestream.png"),
    control_oneclickpolling: require("@/assets/images/meetingcontrol/black/oneclickpolling.png"),
    control_broadcastno: require("@/assets/images/meetingcontrol/common/broadcastno.png"),
    control_close: require("@/assets/images/meetingcontrol/common/close.png"),
    control_locked: require("@/assets/images/meetingcontrol/common/locked.png"),
    control_norecord: require("@/assets/images/meetingcontrol/common/norecord.png"),
    control_novideo: require("@/assets/images/meetingcontrol/common/novideo.png"),
    control_novoice: require("@/assets/images/meetingcontrol/common/novoice.png"),
    control_over: require("@/assets/images/meetingcontrol/common/over.png"),
    boradcastNo: require('@/assets/images/meetingcontrol/common/boradcastNo.png'),
    clickpollingNo: require('@/assets/images/meetingcontrol/common/clickpollingNo.png'),
    VV_call:require('@/assets/images/VVimage/VVcall.png'),
    VV_back:require('@/assets/images/VVimage/VVback.png'),
    VV_date:require('@/assets/images/VVimage/VVdate.png'),
    VV_host:require('@/assets/images/VVimage/VVhost.png'),
    VV_number:require('@/assets/images/VVimage/VVnumber.png'),
    VV_people:require('@/assets/images/VVimage/VVpeople.png'),
    VV_select:require('@/assets/images/VVimage/VVselsect.png'),
    VV_time:require('@/assets/images/VVimage/VVselsect.png'),
    VV_password:require('@/assets/images/VVimage/VVpassword.png'),
    VV_Header:require('@/assets/images/VVimage/vvHeader.png'),
    VV_selecttop:require('@/assets/images/VVimage/VVselsecttop.png'),

  },
  blue: {
    agreement: require("@/assets/images/icons/g_agreement.png"),
    control: require("@/assets/images/icons/g_control.png"),
    exit: require("@/assets/images/icons/g_exit.png"),
    history: require("@/assets/images/icons/g_history.png"),
    inpoint: require("@/assets/images/icons/g_inpoint.png"),
    linklist: require("@/assets/images/icons/g_linklist.png"),
    meetingtemplate: require("@/assets/images/icons/g_meetingtemplate.png"),
    terminalcontrol: require("@/assets/images/icons/g_terminalcontrol.png"),
    meeting: require("@/assets/images/icons/g_meeting.png"),
    message: require("@/assets/images/icons/g_message.png"),
    nopoint: require("@/assets/images/icons/g_nopoint.png"),
    point: require("@/assets/images/icons/g_point.png"),
    position: require("@/assets/images/icons/g_position.png"),
    scan: require("@/assets/images/icons/g_scan.png"),
    index1: require("@/assets/images/icons/index1.png"),
    index2: require("@/assets/images/icons/index2.png"),
    index3: require("@/assets/images/icons/index3.png"),
    index4: require("@/assets/images/icons/index4.png"),
    people: require("@/assets/images/icons/b_people2.png"),
    room: require("@/assets/images/icons/b_room2.png"),
    nowmeet: require("@/assets/images/icons/b_nowmeet2.png"),
    qiu: require("@/assets/images/icons/g_q .png"),
    control_addterminal: require("@/assets/images/meetingcontrol/blue/addterminal.png"),
    control_adduser: require("@/assets/images/meetingcontrol/blue/adduser.png"),
    control_audiocontrol: require("@/assets/images/meetingcontrol/blue/audiocontrol.png"),
    control_broadcast: require("@/assets/images/meetingcontrol/blue/broadcast.png"),
    control_liveshare: require("@/assets/images/meetingcontrol/blue/liveshare.png"),
    control_lock: require("@/assets/images/meetingcontrol/blue/lock.png"),
    control_splitscreen: require("@/assets/images/meetingcontrol/blue/splitscreen.png"),
    control_template: require("@/assets/images/meetingcontrol/blue/template.png"),
    control_videocontrol: require("@/assets/images/meetingcontrol/blue/videocontrol.png"),
    control_recording: require("@/assets/images/meetingcontrol/blue/recording.png"),
    control_recordover: require("@/assets/images/meetingcontrol/blue/recordover.png"),
    control_recordstart: require("@/assets/images/meetingcontrol/blue/recordstart.png"),
    control_recordstop: require("@/assets/images/meetingcontrol/blue/recordstop.png"),
    control_broadcastpolling: require("@/assets/images/meetingcontrol/blue/broadcastpolling.png"),
    control_checkinrecords: require("@/assets/images/meetingcontrol/blue/checkinrecords.png"),
    control_doublestream: require("@/assets/images/meetingcontrol/blue/doublestream.png"),
    control_oneclickpolling: require("@/assets/images/meetingcontrol/blue/oneclickpolling.png"),
    control_broadcastno: require("@/assets/images/meetingcontrol/common/broadcastno.png"),
    control_close: require("@/assets/images/meetingcontrol/common/close.png"),
    control_locked: require("@/assets/images/meetingcontrol/common/locked.png"),
    control_norecord: require("@/assets/images/meetingcontrol/common/norecord.png"),
    control_novideo: require("@/assets/images/meetingcontrol/common/novideo.png"),
    control_novoice: require("@/assets/images/meetingcontrol/common/novoice.png"),
    control_over: require("@/assets/images/meetingcontrol/common/over.png"),
    boradcastNo: require('@/assets/images/meetingcontrol/common/boradcastNo.png'),
    clickpollingNo: require('@/assets/images/meetingcontrol/common/clickpollingNo.png'),
    VV_call:require('@/assets/images/VVimage/VVcall.png'),
    VV_back:require('@/assets/images/VVimage/VVback.png'),
    VV_date:require('@/assets/images/VVimage/VVdate.png'),
    VV_host:require('@/assets/images/VVimage/VVhost.png'),
    VV_number:require('@/assets/images/VVimage/VVnumber.png'),
    VV_people:require('@/assets/images/VVimage/VVpeople.png'),
    VV_select:require('@/assets/images/VVimage/VVselsect.png'),
    VV_time:require('@/assets/images/VVimage/VVselsect.png'),
    VV_password:require('@/assets/images/VVimage/VVpassword.png'),
    VV_Header:require('@/assets/images/VVimage/vvHeader.png'),
    VV_selecttop:require('@/assets/images/VVimage/VVselsecttop.png'),
  },
  grep: {
    agreement: require("@/assets/images/icons/h_agreement.png"),
    control: require("@/assets/images/icons/h_control.png"),
    exit: require("@/assets/images/icons/h_exit.png"),
    history: require("@/assets/images/icons/h_history.png"),
    inpoint: require("@/assets/images/icons/h_inpoint.png"),
    linklist: require("@/assets/images/icons/h_linklist.png"),
    meetingtemplate: require("@/assets/images/icons/h_meetingtemplate.png"),
    terminalcontrol: require("@/assets/images/icons/h_terminalcontrol.png"),
    meeting: require("@/assets/images/icons/h_meeting.png"),
    message: require("@/assets/images/icons/h_message.png"),
    nopoint: require("@/assets/images/icons/h_nopoint.png"),
    point: require("@/assets/images/icons/h_point.png"),
    position: require("@/assets/images/icons/h_position.png"),
    scan: require("@/assets/images/icons/h_scan.png"),
    index1: require("@/assets/images/icons/index1.png"),
    index2: require("@/assets/images/icons/index2.png"),
    index3: require("@/assets/images/icons/index3.png"),
    index4: require("@/assets/images/icons/index4.png"),
    people: require("@/assets/images/icons/h_people.png"),
    room: require("@/assets/images/icons/h_room.png"),
    nowmeet: require("@/assets/images/icons/h_nowmeet.png"),
    qiu: require("@/assets/images/icons/h_q .png"),
    control_addterminal: require("@/assets/images/meetingcontrol/grep/addterminal.png"),
    control_adduser: require("@/assets/images/meetingcontrol/grep/adduser.png"),
    control_audiocontrol: require("@/assets/images/meetingcontrol/grep/audiocontrol.png"),
    control_broadcast: require("@/assets/images/meetingcontrol/grep/broadcast.png"),
    control_liveshare: require("@/assets/images/meetingcontrol/grep/liveshare.png"),
    control_lock: require("@/assets/images/meetingcontrol/grep/lock.png"),
    control_splitscreen: require("@/assets/images/meetingcontrol/grep/splitscreen.png"),
    control_template: require("@/assets/images/meetingcontrol/grep/template.png"),
    control_videocontrol: require("@/assets/images/meetingcontrol/grep/videocontrol.png"),
    control_recording: require("@/assets/images/meetingcontrol/grep/recording.png"),
    control_recordover: require("@/assets/images/meetingcontrol/grep/recordover.png"),
    control_recordstart: require("@/assets/images/meetingcontrol/grep/recordstart.png"),
    control_recordstop: require("@/assets/images/meetingcontrol/grep/recordstop.png"),
    control_broadcastpolling: require("@/assets/images/meetingcontrol/grep/broadcastpolling.png"),
    control_checkinrecords: require("@/assets/images/meetingcontrol/grep/checkinrecords.png"),
    control_doublestream: require("@/assets/images/meetingcontrol/grep/doublestream.png"),
    control_oneclickpolling: require("@/assets/images/meetingcontrol/grep/oneclickpolling.png"),
    control_broadcastno: require("@/assets/images/meetingcontrol/common/broadcastno.png"),
    control_close: require("@/assets/images/meetingcontrol/common/close.png"),
    control_locked: require("@/assets/images/meetingcontrol/common/locked.png"),
    control_norecord: require("@/assets/images/meetingcontrol/common/norecord.png"),
    control_novideo: require("@/assets/images/meetingcontrol/common/novideo.png"),
    control_novoice: require("@/assets/images/meetingcontrol/common/novoice.png"),
    control_over: require("@/assets/images/meetingcontrol/common/over.png"),
    boradcastNo: require('@/assets/images/meetingcontrol/common/boradcastNo.png'),
    clickpollingNo: require('@/assets/images/meetingcontrol/common/clickpollingNo.png'),
    VV_call:require('@/assets/images/VVimage/VVcall.png'),
    VV_back:require('@/assets/images/VVimage/VVback.png'),
    VV_date:require('@/assets/images/VVimage/VVdate.png'),
    VV_host:require('@/assets/images/VVimage/VVhost.png'),
    VV_number:require('@/assets/images/VVimage/VVnumber.png'),
    VV_people:require('@/assets/images/VVimage/VVpeople.png'),
    VV_select:require('@/assets/images/VVimage/VVselsect.png'),
    VV_time:require('@/assets/images/VVimage/VVselsect.png'),
    VV_password:require('@/assets/images/VVimage/VVpassword.png'),
    VV_Header:require('@/assets/images/VVimage/vvHeader.png'),
    VV_selecttop:require('@/assets/images/VVimage/VVselsecttop.png'),
  },
  public: {
    help: "../images/public/help.png",
    home: "../images/public/home.png",
    scin: "../images/public/scin.png",
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/image.js